import { render, staticRenderFns } from "./项目咨询.vue?vue&type=template&id=70ba5a64&scoped=true"
import script from "./项目咨询.vue?vue&type=script&lang=js"
export * from "./项目咨询.vue?vue&type=script&lang=js"
import style0 from "./项目咨询.vue?vue&type=style&index=0&id=70ba5a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba5a64",
  null
  
)

export default component.exports